/**
 * Which video has the network: while a theater player is open, grid previews
 * behind it pause and release their connections.
 *
 * Signed media URLs share one HTTP/1.1 storage host, so browsers allow only a
 * handful of concurrent connections to it. Tiles still loading or looping in
 * the grid would otherwise queue the clip the viewer actually opened.
 */
type Listener = () => void;

let holders = 0;
const listeners = new Set<Listener>();

function emit() {
  for (const listener of listeners) listener();
}

/** Claim focus for a theater player; call the returned function to release it. */
export function holdMediaFocus(): () => void {
  holders += 1;
  emit();
  let released = false;
  return () => {
    if (released) return;
    released = true;
    holders -= 1;
    emit();
  };
}

export function mediaFocusHeld(): boolean {
  return holders > 0;
}

export function subscribeMediaFocus(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
